import createVueApp from '../../shared/vue/create-app';
import axios from 'axios';
import {globalActions} from '../../store/global-actions';
import initCustomControls from '../../components/custom-controls';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';

const initNotificationSettings = (opts) => {
    const page = createVueApp({
        mixins: [openPreviewMixin],
        data() {
            return Object.assign({
                isBuyLocationMode: true,
            }, opts.model);
        },
        methods: {
            saveSattings() {
                axios.post(`${opts.urls.updateUrl}`, this.$data)
                    .then((response) => {
                        if (response && response.data && response.data.redirectUrl) {
                            window.location.href = response.data.redirectUrl;
                        } else {
                            globalActions.openInfoModal(opts.labels.settingsUpdatedTitle, opts.labels.settingsUpdatedMessage);
                        }
                    })
                    .catch(globalActions.handleAjaxErrors);
            },
        },
    });

    initCustomControls(page);
    initCustomInputsComponents(page);
    page.mount('#app');
};

export {initNotificationSettings};
